// extracted by mini-css-extract-plugin
module.exports = {"richTextField":"richText_richTextField__3PeBU","whiteText":"richText_whiteText__3SVp8","blueText":"richText_blueText__2kgkO"};